import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'
import UnlockRoute from '../views/UnlockRoute.vue'
import Route from '../views/Route.vue'
import Settings from '../views/Settings.vue'
import Login from '../views/Login.vue'
import ResetPassword from '../views/ResetPassword.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
import OrderConfirmation from '../views/OrderConfirmation.vue'
import Privacy from '../views/Privacy.vue'
import CookiePolicy from '../views/CookiePolicy.vue'
import Conditions from '../views/Conditions.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { requiresAuth: false }
  },
  {
    path: '/route/:id/unlock',
    name: 'unlockRoute',
    component: UnlockRoute,
    meta: { requiresAuth: false }
  },
  {
    path: '/order-confirmation',
    name: 'orderConfirmation',
    component: OrderConfirmation,
    meta: { requiresAuth: false }
  },
  {
    path: '/route/:id',
    name: 'route',
    component: Route,
    meta: { requiresAuth: false }
  },
  {
    path: '/settings',
    name: 'settings',
    component: Settings,
    meta: { requiresAuth: false }
  },
  {
    path: '/privacypolicy',
    name: 'privacypolicy',
    component: Privacy,
    meta: { requiresAuth: false }
  },
  {
    path: '/conditions',
    name: 'conditions',
    component: Conditions,
    meta: { requiresAuth: false }
  },
  {
    path: '/cookiepolicy',
    name: 'cookiepolicy',
    component: CookiePolicy,
    meta: { requiresAuth: false }
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (!to.matched.some(record => record.meta.requiresAuth))
      return next()

  console.log(to.matched.some(record => record.meta.requiresAuth));
  if (localStorage.getItem('user') == null) {
      next({
          path: '/login',
          params: { nextUrl: to.fullPath }
      })
      return;
  } 
  next()
});

export default router
